'use client';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from './i18n';

type TranslateProps = {
  i18nKey: TranslationKeys;
  values?: any;
  className?: string;
};

const Translate = ({ i18nKey, values, className = '' }: TranslateProps) => {
  const { t } = useTranslation();
  return (
    <div
      dangerouslySetInnerHTML={{ __html: t(i18nKey, values) }}
      className={className}
    />
  );
};

export default Translate;
